import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Grid, Divider, Typography, IconButton, Icon } from '@material-ui/core';
import FourWeekBlock from './scheduleComponents/FourWeekBlock';

const styles = theme => ({
});

class CourseDetailSchedule extends Component {
    render() {
        if (this.props.Unscheduled) {
            let orderedList = this.props.mappedLessons.sort((a, b) => a.DisplayOrder - b.DisplayOrder)
            return (
                <Grid container spacing={8}>
                    <Grid item xs={6}>
                        <List>
                            {orderedList.map((lesson, i) => {
                                let details = (
                                <Typography>
                                    {lesson.LessonDescription}
                                </Typography>
                                )
                                return (
                                    <ListItem key={i}>
                                        <ListItemIcon><b>{i + 1}</b></ListItemIcon>
                                        <ListItemText>
                                            <ExpansionPanel style={{ backgroundColor: 'lightgrey' }} >
                                                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                                    <Typography>{lesson.LessonName}</Typography>
                                                </ExpansionPanelSummary>
                                                <ExpansionPanelDetails>
                                                    {details}
                                                </ExpansionPanelDetails>
                                            </ExpansionPanel>
                                        </ListItemText>
                                    </ListItem>
                                )
                            })}
                        </List>
                    </Grid>
                </Grid>
            )
        }
        else {
            return (
                <Grid container spacing={24}>
                    <Grid item xs={12}>
                        <Typography>Active Month:
                                        <IconButton
                                onClick={(ev) => {
                                    this.props.toggleMonth('DOWN')
                                }}
                                disabled={this.props.month === 1}
                            >
                                <Icon>keyboard_arrow_left</Icon>
                            </IconButton>
                            {this.props.month}
                            <IconButton
                                onClick={(ev) => {
                                    this.props.toggleMonth('UP')
                                }}
                                disabled={this.props.month === 6}
                            >
                                <Icon>keyboard_arrow_right</Icon>
                            </IconButton>
                        </Typography>
                        <FourWeekBlock key={this.props.month} month={this.props.month} mappedLessons={this.props.mappedLessons} detail={true} />
                    </Grid>
                </Grid>
            )
        }
    }
}

export default CourseDetailSchedule


// WEBPACK FOOTER //
// src/main/content/course/CourseDetailSchedule.js